/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HeatLoadByCustomValueRequestPost } from '../../models/heat-load-by-custom-value-request-post';
import { HeatLoadByCustomValueResponse } from '../../models/heat-load-by-custom-value-response';

export interface CalculationsControllerCustomValue$Params {
      body: HeatLoadByCustomValueRequestPost
}

export function calculationsControllerCustomValue(http: HttpClient, rootUrl: string, params: CalculationsControllerCustomValue$Params, context?: HttpContext): Observable<StrictHttpResponse<HeatLoadByCustomValueResponse>> {
  const rb = new RequestBuilder(rootUrl, calculationsControllerCustomValue.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HeatLoadByCustomValueResponse>;
    })
  );
}

calculationsControllerCustomValue.PATH = '/planning-projects/v1/calculations/heat-load/custom-value';
